import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headFlex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(4),
  },
  contentList: {
    listStyleType: "disc",
    marginLeft: theme.spacing(10),
  },
  radio: {
    visibility: "hidden",
    width: 0,
    height: 0,
  },
  typeSection: {
    margin: "30px 0 10px 0",
  },
  bankIcons: {
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "left",
    }
  },
  OxxoSelected: {
    width: "125px",
    height: "70px",
    padding: "15px 20px",
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: ".25rem",
  },
  bbvaSelected: {
    width: "125px",
    height: "70px",
    padding: "15px 10px",
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: ".25rem",
  },
  OxxoImage: {
    width: "125px",
    height: "70px",
    padding: "15px 20px",
    border: `2px solid #d8dadd`,
    borderRadius: ".25rem",
  },
  bbvaImage: {
    width: "125px",
    height: "70px",
    padding: "15px 10px",
    border: `2px solid #d8dadd`,
    borderRadius: ".25rem",
  },
  statusFilterer: {
    marginBottom: theme.spacing(1),
  },
  formWhereStatement: {
    padding: "6px 0",
  },
  cieDescription: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0",
  },
  bottomDescription: {
    fontSize: theme.typography.pxToRem(12),
  },
  submitButton: {
    margin: "15px 0 25px 0",
  },
  bankLogo: {
    width: 130,
    height: 80,
  },
}));

export default useStyles;
